function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.731 5.608c1.977 1.744 2.275 4.215 2.054 6.334l-.03.263-.036.259-.04.254-.043.249-.046.244-.05.237-.08.344-.054.221-.084.316-.113.393-.11.355-.129.386-.238.678-.052.178-.024.09-.044.18c-.356 1.606.036 3.39 2.102 3.234 1.037-.08 1.657-1.365 1.885-2.212.385-1.43 2.47-1.811 3.48-.647 4.944 5.697 5.468 16.734-3.527 22.31-4.715 2.922-14.586 3.103-18.822-7.268-1.41-3.933-.649-7.303 1.177-10.608l.204-.36c.104-.18.21-.36.32-.54l.223-.36.23-.359.238-.36.122-.18.247-.36.254-.36.26-.362.265-.362.27-.363.276-.364.28-.365.428-.55.437-.554.444-.558 1.522-1.894c2.317-2.888 2.33-5.157 1.645-6.78-.591-1.399.928-2.79 2.508-2.246 1.027.354 1.847.817 2.497 1.355l.154.132z",
  fill: "#FF5532"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.25 24.764c-.85.75-2.566 3.557-2.993 4.216-1.848 2.85-2.35 7.192 1.516 9.588 2.027 1.256 6.269 1.334 8.09-3.123.605-1.69.278-3.139-.507-4.56l-.087-.154c-.045-.077-.09-.155-.138-.232l-.096-.154a13.023 13.023 0 0 0-.099-.155l-.102-.155a15.2 15.2 0 0 0-.052-.077l-.107-.155-.109-.155-.111-.155-.114-.155-.116-.156-.119-.157-.12-.157-.184-.236-.188-.238-.19-.24-.655-.814c-.996-1.241-.664-2.213-.663-3.007 0-.794-.8-1.033-1.48-.799-.294.102-.753.512-1.377 1.23z",
  fill: "#FFCE7D"
}));

function SvgIco44Fire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco44Fire);
export default __webpack_public_path__ + "static/media/ico_44_fire.49ec46cd.svg";
export { ForwardRef as ReactComponent };